import { postApi, getApi, putApi, deleteApi } from "../apis";

// Submit a contact form
export const submitContactForm = (contactData) => {
    return postApi('/api/contacts', contactData);
};

// Get all contact submissions
export const getAllContacts = () => {
    return getApi('/api/contacts');
};

// Update contact status or reason
export const updateContact = (id, updateData) => {
    return putApi(`/api/contacts/${id}`, updateData);
};

// Delete a contact record
export const deleteContact = (id) => {
    return deleteApi(`/api/contacts/${id}`);
};
